import React from 'react';
import Key from './Key';

const Keyboard = ({
  layout,
  pressedKeys,
  activeModifiers,
  savedShortcuts = []
}) => {
  const getKeyClassName = (key) => {
    let className = key.className || '';

    // Check for clashes with active modifiers
    if (layout.clashes) {
      activeModifiers.forEach(modifier => {
        if (layout.clashes[modifier]?.includes(key.id)) {
          className += ' alert';
        }
      });
    }

    // Check if key is part of any saved shortcuts for active modifiers
    if (savedShortcuts.length > 0 && activeModifiers.size > 0) {
      const relevantShortcuts = savedShortcuts.filter(shortcut =>
        // Check if the shortcut uses any of the currently active modifiers
        shortcut.keys.some(k => activeModifiers.has(k)) &&
        // Check if this key is part of the shortcut
        shortcut.keys.includes(key.id)
      );

      if (relevantShortcuts.length > 0) {
        className += ' assigned';
      }
    }

    return className;
  };

  return (
      <div className={`keyboard ${layout.platform.toLowerCase()}`}>
        {layout.keys.map((row, rowIndex) => (
          <div key={rowIndex} className="row">
            {row.keys.map((key) => (
              <Key
                key={key.id}
                keyCode={key.id}
                pressedKeys={pressedKeys}
                activeModifiers={activeModifiers}
                className={getKeyClassName(key)}
                shiftedKey={key.shifted}
              >
                {key.display}
              </Key>
            ))}
          </div>
        ))}
      </div>
    );
};

export default Keyboard;
